/*
 * @Author: mayanxia 
 * @Date: 2023-06-13 09:18:02 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-06-15 11:14:42
 */


<template>
    <a-modal
      :width="modalWidth"
      :visible="visible"
      :title="title"
      :maskClosable="maskClosable"
      destroyOnClose
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel"
      :cancelText="$t('关闭')"
      wrapClassName="ant-modal-cust-warp"
      >
      <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
      </template>
      <div class="form-contain">
        <a-divider orientation="left">{{ $t('基本数据') }}</a-divider>
        <detail-list v-if="model.userId">
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
          <detail-list-item :term="$t('用户手机号')">{{model.userPhone}}</detail-list-item>
          <detail-list-item :term="$t('用户地址')" style="width:100%;">{{model.userAreaName.slice(model.userAreaName.indexOf('-')+1,model.userAreaName.length)+'-'+model.userAddr}}</detail-list-item>
        </detail-list>
        <detail-list v-else>
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <detail-list-item :term="$t('表类型')">{{model.mtName}}</detail-list-item>
          <detail-list-item :term="$t('表口径')">DN{{model.mtCaliber}}</detail-list-item>
          <detail-list-item :term="$t('运营商')">{{$t(netTypeObj[model.mtIotType]) }}</detail-list-item>
          <detail-list-item :term="$t('sim卡号')">{{model.mtSim}}</detail-list-item>
          <detail-list-item :term="$t('IMEI号')">{{model.mtImei}}</detail-list-item>
        </detail-list>
        <a-layout id="components-layout-demo-top-side">
          <a-layout-content>
            <a-layout style="padding: 24px 0; background: #fff">
              <a-select default-value="" style="width: 200px" v-model="commandKey" @change="handleClick" :placeholder="$t('选择命令')">
                <a-select-opt-group :label="$t('写命令')">
                  <a-select-option v-for="item in writeCommandList" :key="item.key" :value="item.key">
                    {{ $t(item.title) }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
              <a-layout-content :style="{ padding: '0 24px',margin: '24px 0' }">
                <!-- 强制开关阀 -->
                <a-form-model v-if="commandKey == 5" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('开关阀') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="14">
                      <a-form-model-item :label="$t('控制类型')" prop="valveOperate" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-model="formModel.valveOperate" :placeholder="$t('请选择控制类型')" style="width: 150%">
                          <a-select-option v-for="item in randomnessList"  :value="item.key" :key="item.key" :label="$t(item.title)">
                            {{ $t(item.title) }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <a-form-model v-if="commandKey == 7" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('配置表上报参数') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="18">
                      <a-form-model-item :label="$t('日上报类型')" prop="dayType" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-model="formModel.dayType" style="width: 47%" @change="handleChange">
                          <a-select-option v-for="period in dayTypeList" :key="period.key" :value="period.key">
                            {{ $t(period.title) }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <template v-if="formModel.dayType ==1">
                      <a-col :span="18">
                        <a-form-model-item  :label="$t('小时')" prop="hours" :labelCol="labelCol" :wrapperCol="wrapperCol">
                          <a-select v-model="formModel.hours" style="width: 50%;margin-left:5px;" @change="handleChange">
                            <a-select-option v-for="cycle in hoursOfDay" :key="cycle.key" :value="cycle.key">
                              {{ cycle.title }}
                            </a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                    </template>
                    <template v-if="formModel.dayType ==2">
                      <a-col :span="18">
                        <a-form-model-item :label="$t('小时')" prop="hours" :labelCol="labelCol" :wrapperCol="wrapperCol">
                          <a-select mode="multiple" v-model="formModel.hours" style="width: 50%;margin-left:5px;" @change="handleChange">
                            <a-select-option v-for="cycle in hoursOfDay" :key="cycle.key" :value="cycle.key">
                              {{ cycle.title }}
                            </a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                    </template>
                    <a-col :span="18">
                      <a-form-model-item :label="$t('使用设备尾号增加随机性')" prop="useMantissa" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-switch v-model="formModel.useMantissa" :checked-children="$t('开启')" :un-checked-children="$t('关闭')" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
                <!-- 配置表工作参数 -->
                <a-form-model v-if="commandKey == 11" ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <h2>{{ $t('配置表工作参数') }}</h2><a-divider />
                  <a-row :gutter="16">
                    <a-col :span="18">
                      <a-form-item  :label="$t('采集间隔')" prop="reportInterval"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <!-- <a-input v-model="formModel.reportInterval" placeholder="" suffix="分"
                        ></a-input> -->

                        <a-select v-model="formModel.reportInterval" style="width: 50%;margin-left:5px;" @change="handleChange">
                          <a-select-option v-for="cycle in reportIntervalList" :key="cycle" :value="cycle">
                            {{ cycle }}{{ $t('分') }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form-model>
              </a-layout-content>
            </a-layout>
          </a-layout-content>
        </a-layout>
        <a-row>
          <a-col :span="7">
          </a-col>
          <a-col :span="8">
            <a-button type="primary" block size="large" @click="handleSubmit">
              {{ $t('加入队列') }}
            </a-button>
          </a-col>
        </a-row>
      </div>
    </a-modal>
</template>

<script>
import i18n from '@/i18n'
//端云科技大口径水表
  import { postAction } from '@/api/manage'
  import { isNull,isUndefinedAndNull } from '@/utils/validate'
  import {paramsToFormData} from '@/utils/util'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import moment from 'moment'
  import { USER_AUTH} from "@/store/mutation-types"
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  const originalWriteCommandList = [
    {key: 5, title: i18n.t('开关阀')},
    {key: 7, title: i18n.t('配置表上报参数')},
    {key: 11, title: i18n.t('配置表工作参数')},
  ]
  const randomnessList = [
    {key: 1, title: i18n.t('开阀')},
    {key: 0, title: i18n.t('关阀')},
    {key: 2, title: i18n.t('预付费阀控（由系统控制，对标透支是否关阀）')}
  ]
  const dayTypeList = [
    {key: 0, title:i18n.t('24小时随机(1天一次)')},
    {key: 1, title:i18n.t('自定义随机(1天一次)')},
    {key: 2, title:i18n.t('自定义(1天多次)')},
  ]
  let arrone= [];
  for (let i = 1; i < 25; i++) {
    arrone.push({
      key: i,
      title: i
    })
  }
  export default {
    name: 'MeterDykjDebuggingcommandsModal',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        title:this.$t("命令下发"),
        netTypeObj,
        modalWidth:800,
        visible: false,
        confirmLoading: false,
        model:{},
        formModel: {
          
          dayType:0, //日上报类型默认
          useMantissa: false
        },
        commandKey: undefined,
        originalWriteCommandList,
        writeCommandList: [], //写命令
        randomnessList,  //控制类型
        value: 1,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 14 },
        },
        dayTypeList,
        hoursOfDay: arrone,
        reportIntervalList : [
          1,5,10,15,20,30,60
        ],
        maskClosable:false,
        url: {
          sendCommand: '/jeecg-charge/meter/dykj/addCommand'
        },
        cmd: {
          1:'901f',
          2:'a015',
          3: 'a018',
          4: '904f',
          5: 'a017',
          6: 'a014',
          7: '906f',
          8: '903f', 
          9: '907f',
          10: '90af',
          11: '908f',
          12: '905f',
          13: '909f',
          14: 'a019', 
          15: 'a021', 
          16: 'a022', 
          17: 'a023', 
          18: '90bf', 
          19: 'a020',
          20: '90cf',
          21: '90df', 
          22: '90ef',
          23: '90ff',
          24: 'a024',
          25: 'a025',
        }
      }
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      rules () {
        return {
          valveOperate: [{ required: true,  message: this.$t('请选择阀门控制类型!') }],
          dayType: [{ required: true,  message: this.$t('请选择日上报类型!') }],
          hours: [{ required: true,  message: this.$t('请选择小时!') }],
          reportInterval: [{ required: true,  message: this.$t('请选择采集间隔!') }]
        }
      },
    },
    methods: {
      filterAuth() {
        let permissionList = [];
        let authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || "[]");
        console.log(authList)
        for (let auth of authList) {
          if(auth.type != '2') {
            permissionList.push(auth);
          }
        }
        if (permissionList === null || permissionList === "" || permissionList === undefined||permissionList.length<=0) {
          this.commandList = []
          return;
        }
        let permissions = [];
        for (let item of permissionList) {
          if(item.type != '2'){
            //update--begin--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU-------
            if(item.action){
              if(item.action.includes(",")){
                let split = item.action.split(",")
                for (let i = 0; i <split.length ; i++) {
                  if(!split[i] ||split[i].length==0){
                    continue;
                  }
                  permissions.push(split[i]);
                }
              }else{
                permissions.push(item.action);
              }
            }
            //update--end--autor:wangshuai-----date:20200729------for：按钮权限，授权标识的提示信息是多个用逗号分隔逻辑处理 gitee#I1OUGU------
          }
        }
        console.log(permissions)
        let writeCmdList = []
        for(let item of this.originalWriteCommandList) {
          if(permissions.includes('dykjcommand'+item.key)) {
            writeCmdList.push(item)
          }
        }
        this.writeCommandList = writeCmdList
      },
      handleClick(e) {
        this.$nextTick(() => {
          if (this.$refs.formModel !==undefined) {
            this.$refs.formModel.clearValidate()
          }
        })
        console.log('click ', e.key);
      },
      edit(record) {
        this.filterAuth();
        this.visible = true;
        this.model = Object.assign({}, record);
        this.formModel.meterId = record.meterId
      },
      handleSubmit() {
        console.log(this.formModel)
        if(isUndefinedAndNull(this.commandKey)) {
          this.$message.error(this.$t("请先选择命令"))
          return
        }
        this.$refs.formModel.validate(valid => {
          if (valid) {
            this.confirmLoading = true
            this.sendCommand(this.setCommandParams())
          }
        })   
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      handleCancel() {
        this.close()
      },
      close () {
        this.$emit('close');
        this.commandKey = this.$options.data.call(this).commandKey;
        this.formModel = this.$options.data.call(this).formModel;
        this.$nextTick(()=>{
          if (this.$refs.formModel !== undefined) {
            this.$refs.formModel.resetFields();
          }
        })
        this.visible = false;
        this.openKeys= ['sub1']
      },
      setCommandParams() {
        let params =  {};
        params.meterType = this.model.mtCode;
        params.meterId = this.formModel.meterId;
        params.cmd = this.cmd[this.commandKey];
        let cmdParam = {deviceCode: this.formModel.meterId};
        if (this.commandKey == 5) {  //设置开关阀
          cmdParam.type = this.formModel.valveOperate;
        }else if (this.commandKey == 7) {  //设置日上报数据
          cmdParam.type = this.formModel.dayType;
          let hoursOfDay = []
          if(this.formModel.dayType == 1) {
            hoursOfDay.push({hour: this.formModel.hours,minute: 0,useMantissa: this.formModel.useMantissa})
            cmdParam.hoursOfDay = hoursOfDay
          }else if(this.formModel.dayType == 2) {
            console.log(this.formModel.hours)
            let hours = this.formModel.hours
            for(let i =0;i<hours.length;i++) {
              hoursOfDay.push({hour: this.formModel.hours[i],minute: 0,useMantissa: this.formModel.useMantissa})
            }
            cmdParam.hoursOfDay = hoursOfDay
          }
        } else if (this.commandKey == 11) {  //设置采集间隔
          cmdParam.value = this.formModel.reportInterval;
        }
        params.cmdParam = JSON.stringify(cmdParam);
        return params
      },
      // 协议下发命令
      sendCommand(params) {
        let formData = paramsToFormData(params)
        console.log(params);
        postAction(this.url.sendCommand, formData).then((res) => {
          this.confirmLoading = false;
          if (res.success && res.code == 0) {
            this.$message.success(res.message)
            this.$emit('ok')
            this.close()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      handleChange(value) {
        console.log(value); 
      },
    }
  }
</script>

<style scoped>
.ant-row{
  margin-top: 8px;
}
.ant-form-item{
  margin-bottom: 8px;
}
.detail-list >>> .content{
  line-height: normal;
}
.character {
 margin: 10px;
 margin-left: 50px;
 font-size: 15px;
}
.form-contain{
  max-height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.form-contain >>> .ant-divider-inner-text{
  color: rgba(24,144,255,0.85);
  font-size: 16px;
}
</style>